/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/431-dropbox': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M11.5.5L8 3.5l4.5 3 3.5-3zM8 3.5L4.5.5 0 3.5l3.5 3zM12.5 6.5l3.5 3-4.5 2.5L8 9zM8 9L3.5 6.5 0 9.5 4.5 12z"/><path pid="1" d="M11.377 13.212L8 10.317l-3.377 2.895L2.5 12.033V13.5L8 16l5.5-2.5v-1.467z"/>'
  }
})
